import Vue from 'vue'
import transMap from './translation-map.json'

Vue.prototype.$t = (str) => {
  return transMap[str]
    ? transMap[str]
    : str
}
